/* app/js/src/components/calendar/expandable/calendar-expandable-in-out-picker/calendar-expandable-in-out-picker.component.scss */
.in-out-picker {
  width: 40px;
  height: 24.4px;
  background-color: rgba(226, 232, 241, 0);
  border: none;
  color: #2dbbfc;
  cursor: pointer;
  font-size: 12px;
}
/*# sourceMappingURL=calendar-expandable-in-out-picker.component.css.map */
